const ALPHA_NUMERIC = new RegExp(/(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/)
const CEDULA = new RegExp(/^\d{11}$/)
const TELEFONOS = new RegExp(/^\((809|829|849)\)\s\d{3}-\d{4}$/)

export {
    ALPHA_NUMERIC,
    CEDULA,
    TELEFONOS
}